import React, { useEffect, useState } from "react";
import axios from "axios";
import SuccessPopup from "../Components/SuccessPopup";
import { MultiSelect } from "primereact/multiselect";

import "./CustomMultiSelect.css"; // import CSS
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "./CustomMultiSelect.css";
import { API_BASE_URL } from "../config/constants";
import { jwtDecode } from "jwt-decode";

export default function AddUser({ onUserAdded }) {
  const [data, setData] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    roleName: "",
    siteIds: [],
  });

  const [errors, setErrors] = useState({}); // store validation errors
  const [success, setSuccess] = useState("User successfully added");
  const [showPopUp, setShowPopUp] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState(null);
  const [items, setItems] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [roles, setRoles] = useState([]);
  const [sites, setSites] = useState([]);
  const [open, setOpen] = useState(false); // Add this line with your other states
  const [isOpen, setIsOpen] = useState(false);


  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSiteChange = (e) => {
    const siteId = Number(e.target.value);
    const newSites = data.siteIds.includes(siteId)
      ? data.siteIds.filter((id) => id !== siteId)
      : [...data.siteIds, siteId];
    setData({ ...data, siteIds: newSites });
    setErrors({ ...errors, siteIds: "" });
  };

  // Validation function
  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!data.email || !emailRegex.test(data.email))
      newErrors.email = "Valid email required";
    if (!data.password || data.password.length < 6)
      newErrors.password = "Password min 6 chars";
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleAddUser = async () => {
    if (!validate()) return; // stop if validation fails
    try {
      const res = await axios.post(`${API_BASE_URL}/create-user`, data);
      setShowPopUp(true);
      // alert("User created successfully!");
      setData({
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        roleName: "",
        siteIds: [],
      });
      setSelectedItems(null);
      setSelectedRole(null);
      setSelectAll(false);
      // if (onUserAdded) onUserAdded();
    } catch (err) {
      setShowPopUp(false);

      alert("Error: " + err.response?.data?.message || err.message);
    }
  };

  useEffect(() => {
    // Sites API
    const getSites = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/site`);
        setSites(res.data);
        const formatted = res.data.map((site) => ({
          label: site.siteName,
          value: site.id,
        }));

        // console.log("formatedd", formatted);
        setItems(formatted);
      } catch (e) {
        console.error("Site API error:", e);
      }
    };

    // Roles API
    const getRoles = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }
        const decoded = jwtDecode(token);
        const loggedInRole = decoded.role.role;
        console.log("loggedInRole", loggedInRole);
        const res = await axios.get(`${API_BASE_URL}/role`);
        // console.log("res get roles",res.data)

        // console.log("ressss role", res.data);
        let filteredRoles = [];
        if (loggedInRole === "Super-Admin") {
          filteredRoles = res.data;
        } else if (loggedInRole === "Admin") {
          filteredRoles = res.data.filter(
            (r) => r.role === "Admin" || r.role === "User"
          );
        } else {
          filteredRoles = res.data.filter((r) => r.role === "User");
        }
        // console.log("filter role", filteredRoles);

        setRoles(filteredRoles);
        // setRoles(res.data);
      } catch (e) {
        console.error("Role API error:", e);
      }
    };

    getSites();
    getRoles();
  }, []);

  return (
    <div className="bg-[#051E1C] pt-[4.6875rem] min-h-screen text-white pl-[6.75rem]">
      <div className="flex items-center gap-3 mb-[4.5rem]">
        <img src="assets/addtocart.svg" alt="Logo" className="w-[2.625rem] h-[2.625rem]" />

        <h2 className="text-[1.4375rem] font-semibold font-poppins">
          Add New User
        </h2>
      </div>

      <div className="flex flex-wrap gap-[3.125rem]">

        {/* First Name */}
        <div className="w-full max-w-[28.125rem]">
          <label className="block text-[1.125rem] font-poppins font-medium mb-[0.8125rem] text-[#676F6E]">
            First Name
          </label>
          <input
            name="firstName"
            value={data.firstName}
            onChange={handleChange}
            className={`w-full font-poppins max-w-[28.125rem] h-[3.4375rem] py-[0.1667rem] px-[1rem] rounded-md bg-[#33504D75] text-white text-[1rem] outline-none placeholder-gray-400 ${errors.firstName ? "border-red-500" : ""
              }`}
            placeholder="Enter first name"
          />
          {errors.firstName && (
            <div className="text-red-500 text-xs mt-1">{errors.firstName}</div>
          )}
        </div>

        {/* Last Name */}
        <div className="w-full max-w-[28.125rem]">
          <label className="block text-[1.125rem] font-poppins font-medium mb-[0.8125rem] text-[#676F6E]">
            Last Name
          </label>
          <input
            name="lastName"
            value={data.lastName}
            onChange={handleChange}
            className={`w-full font-poppins max-w-[28.125rem] h-[3.4375rem] py-[0.1667rem] px-[1rem] rounded-md bg-[#33504D75] text-white text-[1rem] outline-none placeholder-gray-400 ${errors.lastName ? "border-red-500" : ""
              }`}
            placeholder="Enter last name"
          />
          {errors.lastName && (
            <div className="text-red-500 text-xs mt-1">{errors.lastName}</div>
          )}
        </div>

        {/* Email */}
        <div className="w-full max-w-[28.125rem] relative">
          <label className="block text-[1.125rem] font-poppins font-medium mb-[0.8125rem] text-[#676F6E]">
            Email ID
          </label>
          <input
            name="email"
            value={data.email}
            onChange={handleChange}
            className={`w-full font-poppins h-[3.4375rem] py-[0.1667rem] px-[1rem] rounded-md bg-[#33504D75] text-white text-[1rem] outline-none placeholder-gray-400 ${errors.email ? "border-red-500" : ""}`}
            placeholder="Enter email"
          />
          <div className="absolute left-0 top-full text-xs text-red-500 pointer-events-none">
            {errors.email || ""}
          </div>
        </div>

        {/* Password */}
        <div className="w-full max-w-[28.125rem] relative">
          <label className="block text-[1.125rem] font-poppins font-medium mb-[0.8125rem] text-[#676F6E]">
            Password
          </label>
          <input
            name="password"
            type="password"
            value={data.password}
            onChange={handleChange}
            className={`w-full font-poppins h-[3.4375rem] py-[0.1667rem] px-[1rem] rounded-md bg-[#33504D75] text-white text-[1rem] outline-none placeholder-gray-400 ${errors.password ? "border-red-500" : ""}`}
            placeholder="Enter password"
          />
          <div className="absolute left-0 top-full text-xs text-red-500 pointer-events-none">
            {errors.password || ""}
          </div>
        </div>

        {/* Sites */}
        <div className="flex flex-col w-full max-w-[28.125rem]">
          <label className="block text-[1.125rem] font-poppins font-medium mb-[0.8125rem] text-[#676F6E]">
            Select Site
          </label>

          <MultiSelect
            value={selectedItems}
            options={items}
            onChange={(e) => {
              setSelectedItems(e.value);
              setData((prev) => ({ ...prev, siteIds: e.value }));
            }}

            maxSelectedLabels={3}
            placeholder="Select Sites"
            className="w-full font-poppins border-none max-w-[28.125rem] h-[3.4375rem] custom-multiselect no-focus-ring"
            style={{
              backgroundColor: isOpen ? "#0A3D38" : "#33504D75",
              borderRadius: "6px",
              fontSize: "1rem",
            }}

            panelStyle={{
              fontSize: "14px",
              backgroundColor: "#0A3D38",
            }}

            /* 🔥 THESE THREE LINES FIX EVERYTHING */
            showSelectAll={false}
            showClear={false}
            panelHeaderTemplate={null}

            onShow={() => setIsOpen(true)}
            onHide={() => setIsOpen(false)}

            dropdownIcon={
              <img
                src={
                  isOpen
                    ? "/assets/dropdown-icon.svg"
                    : "/assets/dropdown-open.svg"
                }
                alt="dropdown"
                className="w-[1rem] h-[1rem]"
              />
            }
          />

        </div>


        {/* Role */}
        <div className="flex flex-col w-full max-w-[28.125rem]">
          <label className="block text-[1.125rem] font-poppins font-medium mb-[0.8125rem] text-[#676F6E]">
            Select Role
          </label>

          <div className="relative">
            <button
              type="button"
              onClick={() => setOpen(!open)}
              className={`w-full font-poppins max-w-[28.125rem] h-[3.4375rem] py-[0.1667rem] px-[1rem] flex items-center justify-between rounded-md text-[1rem] transition-colors
  ${open ? "bg-[#0A3D38]" : "bg-[#33504D75]"}
  ${selectedRole ? "text-white" : "text-white/60"}
`}

            >
              <span>{selectedRole || "Select Role"}</span>
              <img
                src={open ? "/assets/dropdown-icon.svg" : "/assets/dropdown-open.svg"}
                alt="dropdown"
                className="w-4 h-4 transition-transform"
              />

            </button>

            {open && (
              <div
                className="absolute top-full w-full max-w-[28.125rem] bg-[#0A3D38] rounded-[6px] shadow-lg z-50 max-h-56 overflow-y-auto"
                style={{ fontSize: "1rem" }} // same as MultiSelect
              >
                {roles.map((item, index) => (
                  <div
                    key={item.id}
                    onClick={() => {
                      setSelectedRole(item.role);
                      setData((prev) => ({ ...prev, roleName: item.role }));
                      setOpen(false);
                    }}
                    className={`flex items-center gap-[0.667rem] px-[1rem] py-[0.333rem] h-[3.417rem] border-t-[0.083rem] border-b-[0.083rem] border-[#FFFFFF24] cursor-pointer hover:bg-[#072E2A] text-white text-[1rem] ${index !== 0 ? "border-t border-[#FFFFFF24]" : ""}`}
                  >
                    <div
                      className={`w-4 h-4 rounded-full border flex items-center justify-center ${selectedRole === item.role ? "border-[#F3E5DE]" : "border-[#F3E5DE]/50"
                        }`}
                    >
                      {selectedRole === item.role && (
                        <div className="w-2 h-2 bg-[#F3E5DE] rounded-full" />
                      )}
                    </div>
                    <span className="text-[#CACCCC] text-[1rem] font-medium font-poppins not-italic">{item.role}</span>
                  </div>
                ))}
              </div>
            )}

          </div>
        </div>

      </div>


      <button
        onClick={handleAddUser}
        className="mt-20 w-full max-w-[28.125rem] h-[3.75rem] px-[1.667rem] py-[0.833rem] bg-[#147A6F] text-white rounded-[10px] cursor-pointer text-[1.333rem] font-normal not-italic"
      >
        Add User
      </button>

      {showPopUp && (
        <SuccessPopup
          showPopUp={showPopUp}
          message={success}
          onClose={() => setShowPopUp(false)}
        />
      )}
    </div>
  );
}
